import { all, fork } from 'redux-saga/effects';
import { watchLiveMeetingPageSaga } from './live-meeting/live-meeting.saga-watchers';
import { watchMeetingsPageSaga } from './page-storage/meetingsOld/meetings.saga-watchers';
import { watchUsersPageSaga } from './page-storage/users/users.saga-watchers';
import { watchUserSettingsPageSaga } from './page-storage/user-settings/user-settings.saga-watchers';
import { watchHomePageSaga } from './home/home.saga-watchers';
import { watchMeetingDashboardPageSaga } from './meeting-dashboard/meeting-dashboard.saga-watchers';
import { watchMeetingPageSaga } from './meetings/meetings.saga-watchers';
import { watchMeetingsFormSaga } from './meetings/meeting-form/meeting-form.saga-watchers';
import { watchAgendaItemsPageSaga } from './page-storage/agenda-items/agenda-items.saga.watchers';
import { watchTaskPageSaga } from './page-storage/tasks/tasks.saga.watchers';
import { watchKpiPageSaga } from './page-storage/kpi/kpi.saga.watchers';
import { watchConclusionPageSaga } from './page-storage/conclusions/conclusions.saga.watchers';
import { watchSessionsPageSaga } from './page-storage/sessions/sessions.saga-watchers';
import { watchSingleKpiPageSaga } from './kpi/kpi.saga-watchers';
import { watchUserPageInitialSaga } from './users/users.saga-watchers';
import { watchNotificationsPageSaga } from './page-storage/notifications/notifications.saga-watchers';
import { watchTemplatesPageSaga } from './page-storage/templates/templates.saga-watchers';
import { watchVtoPageSaga } from './vto/vto.saga-watchers';
import { watchCalendarsPageSaga } from './page-storage/calendars/calendars.saga-watchers';
import { watchChartPageSaga } from './chart/chart.saga-watchers';
import { watchNodePageSaga as watchNodesPageSaga } from './page-storage/node/node.saga-watchers';
import { watchBoardsPageStorageSaga } from './page-storage/boards/boards.saga-watchers';
import { watchBoardsPageSaga } from './boards/boards.saga-watchers';
import { watchBoardListsPageStorageSaga } from './page-storage/boardLists/boardLists.saga-watchers';
import { watchLabelsPageStorageSaga } from './page-storage/labels/labels.saga-watchers';
import { watchCheckListsPageStorageSaga } from './page-storage/checklists/checkLists.saga-watchers';
import { watchActivitiesPageStorageSaga } from './page-storage/activities/activities.saga-watchers';
import { watchUsersGroupPageSaga } from './page-storage/user-groups/user-groups.saga-watchers';
import { watchPasswordsPageSaga } from './page-storage/passwords/passwords.saga-watchers';
import { watchPasswordsPageSaga as watchInitPasswordsPageSaga } from './passwords/passwords.saga-watchers';
import { watchPasswordsGroupPageSaga } from './page-storage/password-groups/password-groups.saga-watchers';
import { watchTimeTrackingPageSaga } from './time-tracking/time-tracking.saga-watchers';
import { watchProjectTasksPageStorageSaga } from './page-storage/project-tasks/project-tasks.saga-watchers';
import { watchProjectMembersPageStorageSaga } from './page-storage/project-members/project-members.saga-watchers';
import { watchProjectsPageStorageSaga } from './page-storage/projects/projects.saga-watchers';
import { watchTimerSaga } from './timer/timer.saga-watchers';
import { watchProjectTimesPageStorageSaga } from './page-storage/project-times/project-times.saga-watchers';
import { watchQuartalsPageSaga } from './quartals/quartals.saga-watchers';
import { watchQuartalsPageStorageSaga } from './page-storage/quartals/quartals.saga-watchers';
import { watchCompanyToolsCategoriesPageStorageSaga } from './page-storage/company-tools-categories/company-tools-categories.saga-watchers';
import { watchAgencyToolsPageSaga } from './agency-tools/agency-tools.saga-watchers';
import { watchAnswersPageStorageSaga } from './page-storage/answers/answers.saga-watchers';
import { watchMeetingsInfoPageSaga } from './page-storage/meetings-info/meetings-info.saga-watchers';
import { watchSettingsPageSaga } from './settings/settings.saga-watchers';
import { watchSubscriptionPageSaga } from './subscription/subscription.saga-watchers';
import { watchInvoicesPageSaga } from './invoices/invoices.saga-watchers';
import { watchMeetingsSimplePageStorageSaga } from './page-storage/meetings-simple/meetings-simple.saga-watchers';
import { watchTasksSimplePageStorageSaga } from './page-storage/tasks-simple/tasks-simple.saga-watchers';
import { watchMeetingTasksPageStorageSaga } from './page-storage/meeting-tasks/meeting-tasks.saga-watchers';
import { watchMeetingBoardsPageStorageSaga } from './page-storage/meeting-boards/meeting-boards.saga-watchers';
import { watchMeetingsFolderPageStorageSaga } from './page-storage/meeting-folder/meeting-folder.saga-watchers';
import { watchMeetingsArchivePageStorageSaga } from './page-storage/meeting-archive/meeting-archive.saga-watchers';
import { watchUserTenantsPageSaga } from '../resource/user-tenants/user-tenants.saga-watchers';
import { watchAnnualsPageSaga } from './annuals/annuals.saga-watchers';
import { watchMeetingTemplatesPageSaga } from './page-storage/meeting-templates/meeting-templates.saga-watchers';
import { watchMeetingReportsPageSaga } from './page-storage/reports/reports.saga-watchers';
import { watchSessionTranscriptPageSaga } from './session-transcript/transcripts.saga-watchers';
import { watchWrikePageSaga } from './page-storage/wrike/wrike.saga-watchers';
import { watchPersonalNotesPageStorageSaga } from './page-storage/personal-notes/personal-notes.saga-watchers';
import { watchCompanyContextPageSaga } from './company-context/company-context.saga-watchers';

export function* watchPageSaga() {
  yield all(
    [
      watchHomePageSaga,
      watchLiveMeetingPageSaga,
      watchAnnualsPageSaga,
      watchMeetingDashboardPageSaga,
      watchMeetingReportsPageSaga,
      watchMeetingsPageSaga,
      watchUserPageInitialSaga,
      watchAgendaItemsPageSaga,
      watchMeetingPageSaga,
      watchSessionTranscriptPageSaga,
      watchMeetingsArchivePageStorageSaga,
      watchMeetingsSimplePageStorageSaga,
      watchMeetingsFolderPageStorageSaga,
      watchMeetingBoardsPageStorageSaga,
      watchMeetingsFormSaga,
      watchUsersPageSaga,
      watchUserSettingsPageSaga,
      watchTaskPageSaga,
      watchMeetingTasksPageStorageSaga,
      watchTasksSimplePageStorageSaga,
      watchSessionsPageSaga,
      watchKpiPageSaga,
      watchSingleKpiPageSaga,
      watchConclusionPageSaga,
      watchNotificationsPageSaga,
      watchVtoPageSaga,
      watchTemplatesPageSaga,
      watchCalendarsPageSaga,
      watchChartPageSaga,
      watchNodesPageSaga,
      watchBoardsPageSaga,
      watchBoardsPageStorageSaga,
      watchBoardListsPageStorageSaga,
      watchLabelsPageStorageSaga,
      watchCheckListsPageStorageSaga,
      watchActivitiesPageStorageSaga,
      watchUsersGroupPageSaga,
      watchPasswordsPageSaga,
      watchPasswordsGroupPageSaga,
      watchInitPasswordsPageSaga,
      watchTimeTrackingPageSaga,
      watchProjectTasksPageStorageSaga,
      watchProjectMembersPageStorageSaga,
      watchProjectsPageStorageSaga,
      watchProjectTimesPageStorageSaga,
      watchTimerSaga,
      watchQuartalsPageSaga,
      watchQuartalsPageStorageSaga,
      watchCompanyToolsCategoriesPageStorageSaga,
      watchAgencyToolsPageSaga,
      watchAnswersPageStorageSaga,
      watchMeetingsInfoPageSaga,
      watchSettingsPageSaga,
      watchSubscriptionPageSaga,
      watchInvoicesPageSaga,
      watchUserTenantsPageSaga,
      watchMeetingTemplatesPageSaga,
      watchWrikePageSaga,
      watchPersonalNotesPageStorageSaga,
      watchCompanyContextPageSaga,
    ].map(fork),
  );
}
